import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ICard } from '@interfaces/IAccountants';

@Injectable({
  providedIn: 'root',
})
export class AccountantsViewService {
  constructor(private _http: HttpClient) {}
  baseUrl = `${environment.baseUrl}api/v1/accountants`;

  getAllCards(): Observable<ICard[]> {
    const url = `${this.baseUrl}/cards/`;
    return this._http.get<ICard[]>(url);
  }
}
